module.exports = __webpack_public_path__ + "img/elipsis.291be008.svg";